
const UploadDocument = () => {
    return (
        <div>UploadDocument</div>
    );
}

export default UploadDocument;